<template>
  <div class="acr-title">
    <h1>资产类型管理</h1>
    <el-button class="acr-title-add-button" type="primary" v-on:click="openEditPropertyType">
      新增资产类型
    </el-button>
  </div>
</template>

<script>
export default {
  name: "PropertyTypeTitle",
  methods: {
    //打开添加浮窗
    openEditPropertyType() {
      this.$parent.openEditDialog("add");
    }
  },
}
</script>

<style scoped>

</style>